import styles from './Percentage.module.css';

export const PercentageBar = ({ width }) => {
  return (
    <div className={styles.percentageBar} style={{ maxWidth: `${width}%` }} />
  );
};
